import React, { PropTypes } from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Dropdown, DropdownMenuDivider, DropdownMenuHeader, DropdownMenuItem } from '@bibliocommons/base-dropdown';
import * as Icons from '@bibliocommons/base-icons';
import { SHELF_NAMES } from '../../../constants/ShelfConstants';
import BCGoogleAnalyticsUtils from '@bibliocommons/utils-google-analytics';
import './OnShelfDropdown.scss';

class OnShelfDropdown extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderMovableShelfOptions', 'renderOnShelfOptions');
  }

  static getShelfOptions() {
    return Immutable.Map(SHELF_NAMES).valueSeq().toArray().map(name => ({
      label: OnShelfDropdown.renderAddToShelfButtonContent(name),
      value: name
    }));
  }

  static renderAddToShelfButtonContent(name) {
    return (
      <span>
        <Icons.Books width={20} height={19} color="#666" />
        <FormattedMessage id={`label_shelf_${name}`} />
      </span>
    );
  }

  handleShelfMove(newShelf) {
    const shelf = this.props.currentShelfItem.get('shelf');
    const id = this.props.currentShelfItem.get('id');
    const metadataId = this.props.currentShelfItem.get('metadataId');
    this.props.updateShelfItem(shelf, id, metadataId, { newShelfName: newShelf });
    BCGoogleAnalyticsUtils.event({
      eventCategory: 'NERF Search',
      eventAction: 'Move shelf item',
      eventLabel: shelf
    });
  }

  handleRemoveFromShelf() {
    const shelf = this.props.currentShelfItem.get('shelf');
    const id = this.props.currentShelfItem.get('id');
    const metadataId = this.props.currentShelfItem.get('metadataId');
    this.props.removeShelfItem(shelf, id, metadataId);
  }

  renderMovableShelfOptions() {
    const shelf = this.props.currentShelfItem.get('shelf');
    return OnShelfDropdown.getShelfOptions()
      .filter(option => option.value !== shelf)
      .map((option) => {
        const handleShelfMove = (e) => {
          e.preventDefault();
          this.handleShelfMove(option.value);
        };

        return (
          <DropdownMenuItem key={`on-shelf-dropdown-header-move-${option.value}`}>
            <a href="#move-to-shelf" onClick={handleShelfMove}>
              {option.label}
            </a>
          </DropdownMenuItem>
        );
      });
  }

  renderOnShelfOptions() {
    const shelf = this.props.currentShelfItem.get('shelf');
    const header = (
      <DropdownMenuHeader key="on-shelf-dropdown-header">
        <FormattedHTMLMessage id="change_shelf_location" />
      </DropdownMenuHeader>
    );

    const handleRemoveFromShelf = (e) => {
      e.preventDefault();
      this.handleRemoveFromShelf();
    };

    const deleteOption = (
      <DropdownMenuItem key="on-shelf-dropdown-delete">
        <a href="#remove-from-shelf" className="shelf-delete" onClick={handleRemoveFromShelf}>
          <FormattedMessage id="button_remove_from_shelves" />
        </a>
      </DropdownMenuItem>
    );

    const deleteDivider = <DropdownMenuDivider key="on-shelf-dropdown-delete-divider" />;
    const goToShelfDivider = <DropdownMenuDivider key="on-shelf-dropdown-go-to-shelf-divider" />;

    const goToShelfOption = (
      <DropdownMenuItem key="on-shelf-dropdown-go-to-shelf">
        <a href={`/collection/show/my/library/${shelf}`} target="_parent">
          <FormattedMessage
            id="go_to_my_shelf" values={{
              shelf: <FormattedMessage id={`label_shelf_${shelf}`} />
            }} />
        </a>
      </DropdownMenuItem>
    );

    return ([
      header,
      this.renderMovableShelfOptions(),
      deleteDivider,
      deleteOption,
      goToShelfDivider,
      goToShelfOption
    ]);
  }

  render() {
    const { currentShelfItem } = this.props;
    const shelf = currentShelfItem.get('shelf');

    return (
      <div className="cp-on-shelf-dropdown">
        <Dropdown
          className="btn-default btn-on-shelf"
          selected={OnShelfDropdown.renderAddToShelfButtonContent(shelf)}>
          {this.renderOnShelfOptions()}
        </Dropdown>
      </div>
    );
  }
}

OnShelfDropdown.propTypes = {
  currentShelfItem: ImmutablePropTypes.map,
  updateShelfItem: PropTypes.func.isRequired,
  removeShelfItem: PropTypes.func.isRequired
};

export default OnShelfDropdown;



// WEBPACK FOOTER //
// ./app/components/shared/OnShelfDropdown/OnShelfDropdown.jsx